<template>
  <div class="page page-outfit">
    <div class="page-title" v-if="page.header">
      <HTMLDisplay :content="page.header" />
    </div>
    <div class="playbook-page-content">
      <div class="playbook-page-column" v-for="(columnItems, index) in page.columns" :key="index">
        <PageColumnItem v-for="(item, itemIndex) in columnItems" :key="itemIndex" :item="item" :itemsCount="columnItems.length" :pageType="'Outfit'" :precoloredDesignShadow="page.precoloredShadow"
          :designDimension="page.precoloredDimension"  :sportName="page.name"  :pageId="pageId" :columnIndex="index" :itemIndex="itemIndex"/>
      </div>
    </div>
  </div>
</template>

<script>
import HTMLDisplay from "@/components/Projects/Playbooks/HTMLDisplay.vue"
import PageColumnItem from "@/components/Projects/Playbooks/PageColumnItem.vue"

export default {
  
  name: "Outfit",
  computed: {
  },

  methods: {
  },
  
  props: {
    page: {
      type: Object,
    },
    readOnly: {
      type: Boolean
    },
    pageId: {
      type: Number
    },
  },

  components: {
    HTMLDisplay, PageColumnItem
  }
}
</script>

<style lang="scss" scoped>
  #app {
    .page-outfit {
      display: flex;
      flex-direction: column;
      padding: 2em;
    }
  }
</style>